<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">لیست نقشه های راه</h1>
          <div class="my-2">
            <b-row>
              <b-col cols="12" class="mb-1">
                <div
                  class="d-flex flex-column flex-md-wrap flex-md-row align-items-center"
                >
                  <b-form-group
                    class="d-inline-block mr-md-2"
                    label="جستجوی زبان آموز"
                    label-for="studentFullName"
                  >
                    <b-form-input
                      id="studentFullName"
                      v-model="roadmapsListFilters.studentFullName"
                      class="d-inline-block mr-md-2"
                      placeholder="نام کاربر"
                      @keydown.enter="setPageNumberAndGetRoadmapList"
                    />
                  </b-form-group>
                  <language-picker
                    class="mr-md-2"
                    style="min-width: 15rem"
                    @getLanguage="setLanguage"
                  ></language-picker>
                  <b-form-group
                    style="min-width: 15rem"
                    class="d-inline-block mr-md-2"
                    label="وضعیت نقشه راه"
                    label-for="roadmapGroupStatus"
                  >
                    <b-form-select
                      id="roadmapGroupStatus"
                      v-model="roadmapsListFilters.status"
                      :options="roadmapGroupStatuses"
                    ></b-form-select>
                  </b-form-group>
                  <lesson-picker
                    @getLesson="setLesson"
                    class="mr-md-2"
                    style="min-width: 15rem"
                  ></lesson-picker>
                  <b-form-group
                    style="min-width: 15rem"
                    class="d-inline-block mr-md-2"
                    label="تاریخ ایجاد نقشه راه"
                    label-for="roadmapGroupCreateDate"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="roadmapGroupCreateDate"
                        class="roadmapGroupCreateDate"
                        placeholder="تاریخ ایجاد"
                      ></b-form-input>
                      <b-input-group-append>
                        <!-- <b-input-group-text> -->
                        <b-button
                          @click="clearDateFilter"
                          variant="transparent"
                          class="custom-clear-btn"
                          size="sm"
                        >
                          <template v-if="roadmapsListFilters.createDate">
                            <feather-icon
                              class="cursor-pointer"
                              icon="XIcon"
                              size="18"
                            />
                          </template>
                          <template v-else>
                            <feather-icon
                              class="cursor-pointer"
                              icon="ClockIcon"
                              size="18"
                            />
                          </template>
                        </b-button>
                        <date-picker
                          v-model="roadmapsListFilters.createDate"
                          customInput=".roadmapGroupCreateDate"
                          format="YYYY/MM/DD HH:mm"
                          display-format="jYYYY-jMM-jDD"
                          type="date"
                        ></date-picker>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                  <b-button
                    variant="primary"
                    @click="setPageNumberAndGetRoadmapList"
                  >
                    اعمال
                  </b-button>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-table
                  ref="refUserListTable"
                  class="position-relative"
                  :items="roadmapsList"
                  responsive
                  :fields="myTableColumns"
                  primary-key="id"
                  show-empty
                  bordered
                  striped
                  empty-text="موردی موجود نیست!"
                >
                  <template #cell(status)="data">
                    {{
                      data.item.status == 1 ? "در حال برگزاری" : "پایان یافته"
                    }}
                  </template>
                  <template #cell(createDate)="data">
                    {{
                      new Date(data.item.createDate).toLocaleDateString("fa-IR")
                    }}
                  </template>
                  <template #cell(languageTitle)="data">
                    <p style="white-space: nowrap !important">
                      {{ data.item.langPersiantitle }}
                    </p>
                  </template>
                  <template #cell(isGraduated)="data">
                    <b-badge
                      style="font-weight: normal"
                      :variant="data.item.isGraduated ? 'success' : 'warning'"
                    >
                      {{
                        data.item.isGraduated
                          ? "فارغ‌اتحصیل شده"
                          : "فارغ‌اتحصیل نشده"
                      }}
                    </b-badge>
                  </template>
                  <template #cell(lessonTitles)="data">
                    <template v-if="data.item.lessonTitles">
                      <div class="line-clamp-2">
                        {{ data.item.lessonTitles }}
                      </div>
                    </template>
                    <template v-else>-</template>
                  </template>
                  <template #cell(actions)="data">
                    <b-link :to="`/students/roadmaps/${data.item.id}`">
                      <feather-icon
                        class="cursor-pointer"
                        icon="EditIcon"
                        size="18"
                      />
                    </b-link>
                  </template>
                </b-table>
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
                >
                  <b-pagination
                    v-model="roadmapsListFilters.pageNumber"
                    :total-rows="totalCount"
                    :per-page="roadmapsListFilters.count"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        style="transform: rotate(180deg)"
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  mounted() {
    this.getRoadmapsList();
  },
  watch: {
    pageNumber: {
      handler(val) {
        this.getRoadmapsList();
      },
    },
  },
  data() {
    return {
      isLoading: false,
      roadmapsListFilters: {
        studentFullName: null,
        langId: null,
        status: null,
        createDate: null,
        isGraduated: null,
        lessonId: null,
        pageNumber: 1,
        count: 10,
      },
      roadmapsList: null,
      totalCount: null,
      roadmapGroupStatuses: [
        {
          text: "همه",
          value: null,
        },
        {
          text: "در حال برگزاری",
          value: 1,
        },
        {
          text: "پایان یافته",
          value: 2,
        },
      ],
      myTableColumns: [
        {
          key: "id",
          label: "شناسه نقشه راه",
        },
        {
          key: "studentFullName",
          label: "نام زبان آموز",
        },
        {
          key: "languageTitle",
          label: "زبان",
        },
        {
          key: "status",
          label: "وضعیت نقشه راه",
        },
        {
          key: "createDate",
          label: "تاریخ ثبت",
        },
        {
          key: "isGraduated",
          label: "وضعیت فارغ‌اتحصیلی",
        },
        {
          key: "lessonTitles",
          label: "عنوان درس ها",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
    };
  },
  methods: {
    setPageNumberAndGetRoadmapList() {
      this.roadmapsListFilters.pageNumber = 1;
      this.getRoadmapsList();
    },
    clearDateFilter() {
      if (this.roadmapsListFilters.createDate) {
        this.roadmapsListFilters.createDate = null;
      }
    },
    setLesson(lessonId) {
      this.roadmapsListFilters.lessonId = lessonId;
    },
    setLanguage(languageId) {
      this.roadmapsListFilters.langId = languageId;
    },
    async getRoadmapsList() {
      if (this.roadmapsListFilters.createDate) {
        this.roadmapsListFilters.createDate = new Date(
          this.roadmapsListFilters.createDate
        ).toISOString();
      }
      try {
        this.isLoading = true;
        let _this = this;
        let getRoadmapsList = new GetRoadmapsList(_this);
        getRoadmapsList.setRequestParamDataObj(_this.roadmapsListFilters);
        await getRoadmapsList.fetch((res) => {
          _this.roadmapsList = res.data;
          _this.totalCount = res.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    pageNumber() {
      return this.roadmapsListFilters.pageNumber;
    },
  },
  components: {
    BContainer,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
    LanguagePicker,
    LessonPicker,
    BInputGroupAppend,
    BInputGroupText,
  },
};
import {
  BContainer,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupText,
} from "bootstrap-vue";
import { GetRoadmapsList } from "@/libs/Api/RoadmapGroupSimple";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import LessonPicker from "@/views/components/Lessons/LessonPicker.vue";
</script>
<style scoped>
.custom-clear-btn {
  border: 1px solid #d8d6de !important;
  border-top-right-radius: 0.357rem !important;
  border-bottom-right-radius: 0.357rem !important;
}
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
